// npm run build
// firebase deploy  
//firebase use --add
import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from './screens/Home';
import HowToUse from './components/HowToUse';
import Share from './screens/Share';
import Header from './components/Header';
import HowToDelete from './screens/HowToDelete';
import Privacy from './screens/Privacy';
import PdplTr from './screens/PdplTr';
import PdplEn from './screens/PdplEn';
import TermsOfUseTr from './screens/TermsOfUseTr';
import TermsOfUseEn from './screens/TermsOfUseEn';


function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/share" element={<Share />} />
      <Route path="/delete" element={<HowToDelete />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/pdpl_tr" element={<PdplTr />} />
      <Route path="/pdpl_en" element={<PdplEn />} />
      <Route path="/terms_of_use_tr" element={<TermsOfUseTr />} />
      <Route path="/terms_of_use_en" element={<TermsOfUseEn />} />
    </Routes>
  </BrowserRouter>
  );
}

export default App;
